import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Card, Dimmer, Loader, Button, Segment, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import IndiceDetailTable from './indiceDetailTable';

const {fetchLogisticnIndicesDetail} = Actions;

const LogisticIndicesInfo = ({indiceInfo, handleDetail}) => {
  return (
    <Card raised className='indices-info'>
      <Card.Content className='titles'>
        <Card.Header className='header-title'>
          {indiceInfo.name} <span>{indiceInfo.total}</span>
        </Card.Header>
      </Card.Content>

      <Card.Content extra textAlign='right'>
        <Button color='blue' onClick={() => handleDetail(indiceInfo.name)}>
          Detalle
        </Button>
      </Card.Content>
    </Card>
  );
};

const Loaders = ({loading}) => {
  const message = loading ? 'Buscando resultados...' : 'Obteniendo detalle...';

  return (
    <Segment raised padded='very'>
      <Dimmer active inverted>
        <Loader inverted>{message}</Loader>
      </Dimmer>
    </Segment>
  );
};

const LogisticIndicesResults = ({
  loading,
  logisticIndicesList,
  detail,
  loadingDetail,
  startDate,
  endDate,
  detailName,
  changeDetailName,
}) => {
  const [displayDetail, setDisplayDetail] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => setDisplayDetail(false), [loading]);

  const handleDetail = (name) => {
    const params = {name, startDate, endDate};
    dispatch(fetchLogisticnIndicesDetail(params));
    changeDetailName(name);
    setDisplayDetail(true);
  };

  const onCloseDetail = () => {
    changeDetailName('');
    setDisplayDetail(false);
  };

  if (loading) {
    return <Loaders loading={loading} />;
  }

  if (!loading && !logisticIndicesList.length) {
    return (
      <Card raised fluid>
        <Card.Content textAlign='center'>
          <h3>
            No se encuentra informacion disponible en las fechas seleccionadas
          </h3>
        </Card.Content>
      </Card>
    );
  }

  return (
    <>
      <Card.Group className='indices-group'>
        {logisticIndicesList.map((item, idx) => (
          <LogisticIndicesInfo
            key={idx}
            indiceInfo={item}
            handleDetail={handleDetail}
          />
        ))}
      </Card.Group>

      {loadingDetail && <Loaders />}

      {!loadingDetail && displayDetail && (
        <Card raised fluid className='indices-info'>
          <Card.Content className='titles detail'>
            <Card.Header className='header-title'>
              DETALLE DE {detailName}
              <span>
                <Icon
                  name='close'
                  color='blue'
                  size='large'
                  onClick={onCloseDetail}
                />
              </span>
            </Card.Header>
          </Card.Content>

          <Card.Content className='indice-detail-table' extra>
            <IndiceDetailTable detailName={detailName} dataTable={detail} />
          </Card.Content>
        </Card>
      )}
    </>
  );
};

export default LogisticIndicesResults;
